import { render, staticRenderFns } from "./UCFeatureList.vue?vue&type=template&id=208fb48b&scoped=true&"
import script from "./UCFeatureList.vue?vue&type=script&lang=ts&"
export * from "./UCFeatureList.vue?vue&type=script&lang=ts&"
import style0 from "./UCFeatureList.vue?vue&type=style&index=0&id=208fb48b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208fb48b",
  null
  
)

export default component.exports